<template>
  <main id="container" class="page-container">
    <div class="page-header">
      <div class="container">
        <div class="display-flex is-between">
          <page-header title="이벤트" />
        </div>
      </div>
    </div>
    <div class="page-content event-check event-delivery">
      <div class="container">
        <div class="page-sub-header">
          <h3 class="page-sub-title">
            <span class="prima">동행축제 이벤트에 참여하고</span> 푸짐한 선물
            받으세요.
          </h3>
        </div>
      </div>
      <div class="page-tab-container">
        <div class="container tab-buttons">
          <!-- <router-link to="eatingOut" class="tab-button">외식 활성화</router-link>
          			<router-link to="dineOut" class="tab-button">오늘 식사 한 끼, 밖에서 먹어요</router-link>
					<router-link to="check" class="tab-button">출석체크</router-link>
					<router-link to="ranking" class="tab-button">랭킹게임</router-link>
					<router-link to="dibs" class="tab-button is-active">찜하기</router-link>
					<router-link to="sns" class="tab-button">구매후기</router-link> -->
          <router-link to="delivery" class="tab-button is-active"
          >공공배달앱 이용후기</router-link
          >
          <router-link to="kakaoFriend" class="tab-button"
          >카카오톡 친구추가 이벤트</router-link
          >
          <!-- <router-link to="challenge" class="tab-button">동행 숨결 챌린지</router-link> -->
        </div>
      </div>
      <div class="container">
        <div class="event-check-container">
          <div class="event-check-header">
            <div class="event-check-header-img">
              <div class="banner-img">
                <img
                    src="@/assets/img/event/eventDelivery0428.jpg"
                    alt="EVENT 05 공공배달앱 이용후기 이벤트"
                />
              </div>
            </div>
            <div class="event-check-header-info">
              <ul class="event-check-header-info-list">
                <li v-for="(item, idx) in infoList" :key="idx">
                  <span class="infolist-title">{{ item.title }}</span>
                  <span class="infolist-text">{{ item.detail }}</span>
                </li>
              </ul>
            </div>
          </div>
          <div class="event-check-guide">
            <span class="event-check-guide-title">참여방법</span>
            <div class="event-check-guide-desc no-border">
              <ul class="event-check-guide-desclist">
                <li class="event-check-guide-desclist-li">
                  <div class="event-check-guide-desclist-img hidden-mobile">
                    <img src="@/assets/img/event/icon_e51.png" alt="" />
                  </div>
                  <div class="event-check-guide-desclist-text">
                    <span class="desclist-title">STEP 1</span>
                    <span class="desclist-text"
                    >공공배달앱으로 음식 배달 또는 포장 주문
                    </span>
                  </div>
                </li>
                <li class="event-check-guide-desclist-li">
                  <div class="event-check-guide-desclist-img hidden-mobile">
                    <img src="@/assets/img/event/icon_e52.png" alt="" />
                  </div>
                  <div class="event-check-guide-desclist-text">
                    <span class="desclist-title">STEP 2</span>
                    <span class="desclist-text"
                    >공공배달앱 내 포토 후기 작성 (최소 15자) 후 작성한
                      포토후기 캡처</span
                    >
                    <div class="desclist-tag">
                      <span class="tag-title"
                      >이용 후기에 작성일자 보이게 캡처 필수, 동행축제 기간 내
                        이용&후기만 미션으로 인정</span
                      >
                    </div>
                  </div>
                </li>
                <li class="event-check-guide-desclist-li">
                  <div class="event-check-guide-desclist-img hidden-mobile">
                    <img src="@/assets/img/event/icon_e53.png" alt="" />
                  </div>
                  <div class="event-check-guide-desclist-text">
                    <span class="desclist-title">STEP 3</span>
                    <span class="desclist-text"
                    >동행축제 누리집 이벤트 페이지 내 네이버폼에 포토후기 첨부
                    </span>
                    <div class="desclist-tag">
                      <span>https://naver.me/xucLyWQl</span
                      ><span class="accept-button"
                    ><a href="https://naver.me/xucLyWQl" target="_blank"
                    >접수하기</a
                    ></span
                    >
                    </div>
                  </div>
                </li>
                <li class="event-check-guide-desclist-li">
                  <div class="event-check-guide-desclist-img hidden-mobile">
                    <img src="@/assets/img/event/icon_e54.png" alt="" />
                  </div>
                  <div class="event-check-guide-desclist-text">
                    <span class="desclist-title">STEP 4</span>
                    <span class="desclist-text"
                    >경품 수령을 위한 개인 정보 입력 후 접수</span
                    >
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="event-check-products">
            <span class="event-check-products-title">경품소개</span>
            <ul class="event-check-products-list">
              <li
                  class="event-check-products-list-li"
                  v-for="(item, idx) in prdList"
                  :key="idx"
              >
                <div class="event-check-products-item">
                  <div class="event-check-products-item-img">
                    <img
                        :src="require(`@/assets/img/main/${item.img}`)"
                        :alt="item.title"
                    />
                  </div>
                  <div class="event-check-products-item-title">
                    <span class="item-title-wrap">
                      <span class="item-title">{{ item.title }}</span>
                      <span class="item-title boldtxt">{{ item.person }}</span>
                    </span>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="event-check-button-box">
        <div class="container flex-column">
          <span class="event-check-prect-title">당첨안내</span>
          <ul class="event-check-prect-list">
            <li
                class="event-check-prect-list-li"
                v-for="(item, idx) in deliveryInfo"
                :key="idx"
            >
              <span class="prect-list-text" v-html="item"></span>
            </li>
          </ul>
          <!-- <button type="button"  v-if="isShowBtn" class="event-check-button" @click="clickLink('https://naver.me/5neaoDUO')">이용후기 이벤트 참여</button> -->
        </div>
        <div class="container flex-column">
          <span class="event-check-prect-title">경품발송</span>
          <ul class="event-check-prect-list">
            <li
                class="event-check-prect-list-li"
                v-for="(item, idx) in deliveryList"
                :key="idx"
            >
              <span class="prect-list-text" v-html="item"></span>
            </li>
          </ul>
          <div class="into-area" style="width: 100%; text-align: center">
            <button
                type="button"
                v-if="isShowBtn"
                class="event-check-button"
                @click="clickLink('https://naver.me/xucLyWQl')"
            >
              참여하기
            </button>
            <!-- <span class="into-button"><a href="https://naver.me/5bV9JGrN" target="_blank">참여하기</a></span> -->
          </div>
        </div>
      </div>
      <div class="event-check-prect">
        <div class="container">
          <span class="event-check-prect-title">유의사항</span>
          <ul class="event-check-prect-list">
            <li
                class="event-check-prect-list-li"
                v-for="(item, idx) in prectList"
                :key="idx"
            >
              <div class="prect-list-text" v-html="item"></div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </main>
</template>
<style>
.accept-button a {
  width: 80px; /* 버튼 너비 유지 */
  height: 25px; /* 버튼 높이 유지 */
  border-radius: 7px;
  display: inline-flex;
  background-color: #279773;
  color: #ffffff;
  font-size: 17px;
  font-weight: 400;
  justify-content: center;
  align-items: center;
  margin-left: 7px;
}
</style>
<script>
import PageHeader from "@/components/content/PageHeader";
export default {
  name: "EventDelivery",
  components: { PageHeader },
  data: () => ({
    visibleModal: false,
    infoList: [
      {
        title: "참여기간",
        detail: "2025년 5월 1일(목) ~ 2025년 5월 30일(금)",
      },
      {
        title: "결과발표",
        detail: "2025년 6월 중",
      },
      {
        title: "경품발송",
        detail: "2025년 7월 중",
      },
      {
        title: "진행방식",
        detail:
            "전국 15개 공공배달앱 중 1개 이용 후 앱 내 포토 후기 작성 및 캡처 후 네이버폼 접수",
      },
    ],
    prdList: [
      {
        img: "item_gift_certificate.jpg",
        title: "디지털 온누리상품권 5만원",
        person: "(10명)",
      },
      {
        img: "item_gift_certificate.jpg",
        title: "디지털 온누리상품권 1만원",
        person: "(20명)",
      },
      {
        img: "item_image_7.jpg",
        title: "커피쿠폰 ",
        person: "(100명)",
      },
    ],
    deliveryInfo: [
      "네이버폼 접수자 대상 미션 검수 후, 추첨을 통해 당첨자 선정",
    ],
    deliveryList: ["네이버폼 응모 시 등록한 핸드폰 번호로 모바일 쿠폰 전송"],

    prectList: [
      "본 이벤트는 동행축제 기간 내 공공배달앱 이용 포토 후기 작성 후 누리집 이벤트 페이지 내 이벤트 참여하기 버튼을 클릭하여 네이버 폼에 접수 해주시면 응모 완료 됩니다.",
      ' <span style="color: Red;">이용 후기에 작성일자 보이게 캡처 필수, 동행축제 기간 내 이용&후기만 미션으로 인정됩니다.',
      "이벤트 참여 응모를 위한 네이버폼으로 취합 된 개인정보는 이벤트 경품 발송 절차가 모두 완료된 이후에 즉시 폐기 됩니다.",
      '<span style="color: Red;">디지털 온누리상품권의 경우 디지털온누리앱에 가입한 자에게 선물하기를 통해 경품 지급될 예정입니다. <br>*구글플레이스토어 : https://play.google.com/store/apps/details?id=com.komsco.kpay<br><div style="font-size: 19px;">*앱스토어:https://apps.apple.com/kr/app/%EB%94%94%EC%A7%80%ED%84%B8%EC%98%A8%EB%88%84%EB%A6%AC/id6738372450',
      '<span style="color: Red;">이름과 휴대폰 번호가 디지털온누리앱의 가입 정보와 일치한 경우에만 선물을 받을 수 있습니다.',
      "네이버폼 접수 시 기재한 번호로 모바일 쿠폰 전송",
      "지급 된 쿠폰 사용 시, 발송된 쿠폰 내 유의사항을 반드시 확인 바랍니다.",
      "당첨 쿠폰이 분실, 도난 된 경우, 재발송이 불가합니다. (당첨 쿠폰 복사 및 저장 필수)",
      "당첨자는 이벤트 종료 후 1개월 이내 공지될 예정입니다.",
      "당첨자의 잘못된 정보 입력으로 인해 경품 누락이 될 경우 재 발송되지 않습니다.",
      '해당 이벤트에 만 14세 미만은 참여할 수 없습니다. <span style="color: Red;">(만 14세 미만 참여자의 경우 경품 당첨이 취소 됩니다.)',
      "이벤트 일정 및 경품내역은 추후 주최 측의 사정에 따라 변동 가능합니다.",
      '이벤트에 관한 문의는 대행사인 <span style="font-weight: bold;">㈜지엠컴 070-4838-6391</span>로 문의 바라며, 상담 가능 시간은 평일 오전 10시 ~ 오후 7시입니다.',
    ],
  }),
  computed: {
    isShowBtn() {
      return new Date() < new Date("2025-06-01 00:00:00");
    },
  },
  watch: {},
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        const thisTab = document.querySelector(".tab-button.is-active");
        thisTab.scrollIntoView({ behavior: "smooth", block: "center" });
      }, 100);
    });
  },
  methods: {
    clickLink(url) {
      window.open(url, "_blank");
    },
    clickEvent(e) {
      let url = "https://naver.me/5neaoDUO";
      const w = 560;
      const h = 600;
      const title = "이벤트";

      // 브라우저 창의 크기 가져오기
      const dualScreenLeft =
          window.screenLeft !== undefined ? window.screenLeft : window.screenX;
      const dualScreenTop =
          window.screenTop !== undefined ? window.screenTop : window.screenY;

      const width = window.innerWidth
          ? window.innerWidth
          : document.documentElement.clientWidth
              ? document.documentElement.clientWidth
              : screen.width;
      const height = window.innerHeight
          ? window.innerHeight
          : document.documentElement.clientHeight
              ? document.documentElement.clientHeight
              : screen.height;

      // 팝업창의 중앙 좌표 계산
      const left = width / 2 - w / 2 + dualScreenLeft;
      const top = height / 2 - h / 2 + dualScreenTop;

      // 팝업창 설정
      const options = `
				scrollbars=yes,
				width=${w},
				height=${h},
				top=${top},
				left=${left},
				status=no,
				menubar=no,
				toolbar=no,
				location=no,
				directories=no,
				copyhistory=no
			`.replace(/\s+/g, "");

      // 팝업창 열기
      const newWindow = window.open(url, title, options);

      // 팝업창이 차단되었는지 확인
      if (window.focus && newWindow) {
        newWindow.focus();
      }

      return newWindow;
    },
  },
};
</script>
